import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SCol } from './styles.js';
import Card from './Card';
import { Row } from 'react-bootstrap';

const CardsGrid = ({ data, inLine = false }) => {
  // console.log('Data: ' + data);

  {
    /* Refer to /components/CardsGrid/data/ to see how data prop should be structured for CardsGrid
        {
          column_one: [
            {
              title: 'Great Fees',
              description: 'We offer incredibly low fees for our services while providing efficient and transparent services that you’ll love.',
              icon: ChartIcon,
              moveUp: false,
            },
           ],
          column_two: [
            {
                title: 'Premium Advertising',
                description: 'Relax and leave the property managing to us. We provide 24/7 support with our in-house team.',
                icon: CheckIcon,
                moveUp: true,
            },
            {
                title: 'Full Support',
                description: 'Teamwork makes the dream work. Our team can help you 24/7 with issues ranging from compliance, maintenance, viewings and legal issues. We’ll help you with whatever you need.',
                icon: HomeIcon,
                moveUp: true,
            }
          ],
        }
    */
  }

  const column_names = Object.keys(data);

  const [descriptionHeight, setDescriptionHeight] = useState();
  const [footerHeight, setFooterHeight] = useState();
  const [titleHeight, setTitleHeight] = useState();

  let title_height = [];
  let description_height = [];
  let footer_height = [];

  let title_maxValue;
  let description_maxValue;
  let footer_maxValue;

  const callbackTitle = height => {
    // Store heights of each element
    title_height.push(height);

    // find max value from values stored
    title_maxValue = Math.max.apply(Math, title_height);

    // update state with max value
    setTitleHeight(title_maxValue);
  };

  const callbackDescription = height => {
    // Store heights of each element
    description_height.push(height);

    // find max value from values stored
    description_maxValue = Math.max.apply(Math, description_height);

    // update state with max value
    setDescriptionHeight(description_maxValue);
  };

  const callbackFooter = height => {
    // Store heights of each element
    footer_height.push(height);

    // find max value from values stored
    footer_maxValue = Math.max.apply(Math, footer_height);

    // update state with max value
    setFooterHeight(footer_maxValue);
  };

  return (
    <Row
      className={`mb-5 mx-0 h-100 ${
        inLine
          ? 'justify-content-center'
          : 'align-items-center justify-content-center'
      }`}
    >
      {/* Map trough columns*/}
      {column_names.map((name, idx) => {
        // check what column should move up
        const moveColUp = data[name][0].moveUp;

        // console.log('translateY', name, ': ', moveColUp);

        return (
          <SCol key={`column-${idx}`} $moveUp={moveColUp}>
            {/* Map through objects inside columns */}
            {data[name].map((col, key) => (
              <Card
                key={`card-${key}`}
                Icon={col.icon}
                title={col.title}
                description={col.description}
                inLine={inLine}
                callbackTitle={callbackTitle}
                callbackDescription={callbackDescription}
                callbackFooter={callbackFooter}
                titleHeight={titleHeight}
                descriptionHeight={descriptionHeight}
                footerHeight={footerHeight}
                footer={<> {col.footer}</>}
              />
            ))}
          </SCol>
        );
      })}
    </Row>
  );
};

CardsGrid.propTypes = {
  data: PropTypes.object,
  inLine: PropTypes.bool,
};

export default CardsGrid;
